export const getServicesFromUser = (user) => {
  if (!user) return [];

  const serviceProvided =
    user?.service_provided ||
    user?.supplier_details?.service_provided ||
    user?.supplierDetails?.service_provided;

  if (!serviceProvided) return [];

  let services = [];

  if (typeof serviceProvided === "string") {
    try {
      const parsed = JSON.parse(serviceProvided);
      services = Array.isArray(parsed) ? parsed : [];
    } catch {
      services = serviceProvided
        .replace(/[[\]"]/g, "")
        .split(",")
        .map((service) => service.trim())
        .filter(Boolean);
    }
  } else if (Array.isArray(serviceProvided)) {
    services = serviceProvided;
  }

  return services
    .map((service) => String(service).trim().toLowerCase())
    .filter(Boolean);
};

export const syncSupplierUser = (user) => {
  if (!user) return;
  localStorage.setItem("user", JSON.stringify(user));
  window.dispatchEvent(new CustomEvent("supplier-profile-updated"));
};

export const hasSupplierService = (services, service) =>
  services.includes(String(service).trim().toLowerCase());

export const hasAcceptedPlatformTerms = (user) => {
  if (!user) return true;

  const details = user.supplier_details || user.supplierDetails;
  if (!details) return true;

  return Boolean(details.terms_accepted_at);
};
